function stringToBase64URLSafe(str) {
    return btoa(unescape(encodeURIComponent(str)));
}

function objectToBase64URLSafe(obj) {
    return stringToBase64URLSafe(JSON.stringify(obj));
}

function base4URLSafeToString(base64) {
    return atob(base64);
}

function base4URLSafeToObject(base64) {
    if (base64 == null || base64.trim() === "") return null;
    return JSON.parse(base4URLSafeToString(base64));
}

export default {
    stringToBase64URLSafe,
    objectToBase64URLSafe,
    base4URLSafeToString,
    base4URLSafeToObject
}